import { useViewport, Box } from '@farmersdog/corgi-x';
import { ExtendedVideoSection } from '../ExtendedVideoSection';
import { HomepageRedesignSections } from '../CtaTrackerV2';
import styles from '../VetsKnowBest/VetsKnowBest.module.css';
import { useTrackedSectionRef } from '../../../../hooks/useTrackedSections';

const WISTIA_IDS = {
  desktop: 'hfadsk2rqc',
  mobile: 'jm7th76rvo',
};
export const VetVideo = () => {
  const viewport = useViewport();
  const isMobile = !viewport?.lg;
  const wistiaId = isMobile ? WISTIA_IDS.mobile : WISTIA_IDS.desktop;

  const vetVideoRef = useTrackedSectionRef<HTMLDivElement>(
    HomepageRedesignSections.VetVideo
  );

  return (
    <Box px={24} className={styles.videoContainer} ref={vetVideoRef}>
      <ExtendedVideoSection
        className={styles.video}
        wistiaId={wistiaId}
        controlsPosition="center"
        wistiaOptions={{
          autoPlay: false,
          playsinline: true,
          endVideoBehavior: 'reset',
          playPauseNotifier: false,
          videoFoam: true,
        }}
        moduleName={HomepageRedesignSections.VetKnowsBestVideo}
      />
    </Box>
  );
};
